export type CatalogKind = 'tool' | 'toy' | 'game';
export type CatalogBadge = 'popular' | 'multiplayer';

export interface CatalogItem {
  readonly slug: string;
  readonly title: string;
  readonly description: string;
  readonly href: string;
  readonly kind: CatalogKind;
  readonly icon: 'timeline' | 'briefcase' | 'stealth' | 'wavebean' | 'drawing' | 'tail' | 'fortress' | 'marble' | 'fortune' | 'answer' | 'card';
  readonly tone: 'purple' | 'pink' | 'aqua' | 'gold';
  readonly status: 'public' | 'draft' | 'retired';
  readonly badges: readonly CatalogBadge[];
  readonly popularityRank: number | null;
  readonly fallbackOrder: number;
  readonly publishedAt: string;
}

export const catalogItems: readonly CatalogItem[] = [
  {
    slug: 'google-timeline-video',
    title: '내 역마살 추적기',
    description: '구글 타임라인으로 나만의 이동 경로 영상 만들기',
    href: '/tools/google-timeline-video/',
    kind: 'toy',
    icon: 'timeline',
    tone: 'purple',
    status: 'public',
    badges: ['popular'],
    popularityRank: 1,
    fallbackOrder: 1,
    publishedAt: '2026-08-24',
  },
  {
    slug: 'escape-the-office',
    title: '퇴근은 함정',
    description: '무너지는 바닥과 반전 조작을 피해 퇴근 문까지 도착하기',
    href: '/games/escape-the-office/',
    kind: 'game',
    icon: 'briefcase',
    tone: 'pink',
    status: 'public',
    badges: [],
    popularityRank: 2,
    fallbackOrder: 2,
    publishedAt: '2026-08-24',
  },
  {
    slug: 'boss-is-watching',
    title: '사장님 몰래 퇴근하기',
    description: '사장님의 시야를 피해 책상 뒤에 숨고 몰래 퇴근하기',
    href: '/games/boss-is-watching/',
    kind: 'game',
    icon: 'stealth',
    tone: 'purple',
    status: 'public',
    badges: [],
    popularityRank: 3,
    fallbackOrder: 3,
    publishedAt: '2026-08-25',
  },
  {
    slug: 'wavebean-volley',
    title: '파도콩 배구',
    description: 'CPU와 연습하거나 초대 링크로 즐기는 온라인 1대1 배구',
    href: '/games/wavebean-volley/',
    kind: 'game',
    icon: 'wavebean',
    tone: 'aqua',
    status: 'public',
    badges: ['multiplayer'],
    popularityRank: 4,
    fallbackOrder: 4,
    publishedAt: '2026-08-24',
  },
  {
    slug: 'wavebean-drawing-relay',
    title: '파도콩 그림릴레이',
    description: '제시어와 그림을 번갈아 이어 마지막 반전을 공개하는 3~8인 파티 게임',
    href: '/games/wavebean-drawing-relay/',
    kind: 'game',
    icon: 'drawing',
    tone: 'purple',
    status: 'public',
    badges: ['multiplayer'],
    popularityRank: 5,
    fallbackOrder: 5,
    publishedAt: '2026-08-25',
  },
  {
    slug: 'wavebean-tail-chase',
    title: '파도콩 꼬리잡기',
    description: '자동으로 달리는 파도콩을 돌려 벽과 꼬리를 피하는 2~4인 실시간 대전',
    href: '/games/wavebean-tail-chase/',
    kind: 'game',
    icon: 'tail',
    tone: 'aqua',
    status: 'public',
    badges: ['multiplayer'],
    popularityRank: 6,
    fallbackOrder: 6,
    publishedAt: '2026-08-25',
  },
  {
    slug: 'kong-fortress',
    title: '콩포트리스',
    description: '바람을 읽고 각도와 세기를 조절해 코코넛 포탄을 쏘는 2~4인 포격 대전',
    href: '/games/kong-fortress/',
    kind: 'game',
    icon: 'fortress',
    tone: 'gold',
    status: 'public',
    badges: ['multiplayer'],
    popularityRank: 7,
    fallbackOrder: 7,
    publishedAt: '2026-08-25',
  },
  {
    slug: 'fate-marble',
    title: '운명의 마블',
    description: '이름을 넣고 함께 지켜보는 랜덤 마블 추첨 레이스',
    href: '/games/fate-marble/',
    kind: 'game',
    icon: 'marble',
    tone: 'purple',
    status: 'public',
    badges: [],
    popularityRank: 8,
    fallbackOrder: 8,
    publishedAt: '2026-08-26',
  },
  {
    slug: 'today-fortune',
    title: '오늘의 한입 운세',
    description: '생일로 오늘의 포춘쿠키 운세 보기',
    href: '/tools/today-fortune/',
    kind: 'toy',
    icon: 'fortune',
    tone: 'gold',
    status: 'public',
    badges: [],
    popularityRank: 9,
    fallbackOrder: 9,
    publishedAt: '2026-08-24',
  },
  {
    slug: 'my-answer',
    title: '내 대답은…',
    description: '내 대답을 쓸데없이 거창한 연출에 숨겨 링크로 보내기',
    href: '/tools/my-answer/',
    kind: 'toy',
    icon: 'answer',
    tone: 'purple',
    status: 'public',
    badges: [],
    popularityRank: 10,
    fallbackOrder: 10,
    publishedAt: '2026-08-27',
  },
  {
    slug: 'my-card',
    title: '나를 카드로 뽑아!',
    description: '사진 한 장으로 나만의 캐릭터 카드 뽑고 이미지로 저장하기',
    href: '/tools/my-card/',
    kind: 'toy',
    icon: 'card',
    tone: 'purple',
    status: 'public',
    badges: [],
    popularityRank: null,
    fallbackOrder: 11,
    publishedAt: '2026-09-06',
  },
];

export function publicCatalogItems(items: readonly CatalogItem[] = catalogItems): CatalogItem[] {
  return items
    .filter((item) => item.status === 'public')
    .sort((left, right) => {
      const leftRank = left.popularityRank ?? Number.POSITIVE_INFINITY;
      const rightRank = right.popularityRank ?? Number.POSITIVE_INFINITY;
      return leftRank - rightRank
        || left.fallbackOrder - right.fallbackOrder
        || left.publishedAt.localeCompare(right.publishedAt);
    });
}

export function catalogBadgeLabel(badge: CatalogBadge): string {
  return badge === 'popular' ? '인기' : '멀티';
}

export interface CatalogSection {
  readonly id: 'games' | 'tools-play';
  readonly title: '게임' | '도구·놀이';
  readonly description: string;
  readonly items: readonly CatalogItem[];
}

export function catalogSections(items: readonly CatalogItem[] = publicCatalogItems()): CatalogSection[] {
  return [
    {
      id: 'games',
      title: '게임',
      description: '혼자 가볍게, 친구들과는 더 신나게 즐겨보세요.',
      items: items.filter((item) => item.kind === 'game'),
    },
    {
      id: 'tools-play',
      title: '도구·놀이',
      description: '필요한 순간 쓰거나 오늘의 재미를 가볍게 확인해요.',
      items: items.filter((item) => item.kind !== 'game'),
    },
  ];
}
